import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {LuminariaService} from "../../../services/luminaria.service";
import {luminaria} from "../../../models/luminaria";
import {Localiser} from "../../../services/localiser";
import {UserService} from "../../../services/user.service";
import {zona} from "../../../models/zona";
import {plano} from "../../../models/plano";
import {ZonaService} from "../../../services/zona.service";
import {PlanoService} from "../../../services/plano.service";
import {Model, modelList} from '../../../commons/util';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditComponent implements OnInit {

  selectedLumToEdit: luminaria;
  name: string;
  serialNumber: string;
  installationDate: Date;
  hasEmergency: boolean;
  modelLed: string;
  lux: number;
  consumoPorHora: number;

  zonas: Array<zona> = [];
  planos: Array<plano> = [];
  showZonas = [];
  showPlanos = [];
  proyectoSelected = undefined;
  planoSelected = undefined;
  zonaSelected = undefined;
  changingProyecto: boolean = false;


  constructor(public localiser: Localiser, public dialogRef: MatDialogRef<EditComponent>,
              private luminariaService: LuminariaService, public user: UserService,
              public zonaService: ZonaService, public planoService: PlanoService,
              public userService: UserService) { }

  ngOnInit(): void {
    this.selectedLumToEdit = this.luminariaService.getLumToEdit();
    this.checkPlanoAndZonaSelected();
    this.name = this.selectedLumToEdit.nombre;
    this.serialNumber = this.selectedLumToEdit.numSerie;
    this.installationDate = new Date(this.selectedLumToEdit.fechaInstalacion * 1000);
    this.hasEmergency = this.selectedLumToEdit.tieneEmergencia;
    this.modelLed = this.selectedLumToEdit.ledModelo;
    this.lux = this.selectedLumToEdit.nominalLux;
    this.consumoPorHora = this.selectedLumToEdit.consumoPorHora;
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onSaveClick(): void {

    let idProyectoUpdtate = "-1";
    if (this.proyectoSelected != null && this.proyectoSelected != undefined) {
      idProyectoUpdtate = this.proyectoSelected.idProyecto;
    }

    let idPlanoUpdate = "-1";
    if (this.planoSelected != null && this.planoSelected != undefined) {
      idPlanoUpdate = this.planoSelected.idPlano;
    }

    let idZonaUpdate = "-1";
    if (this.zonaSelected != null && this.zonaSelected != undefined) {
      idZonaUpdate = this.zonaSelected.id;
    }
    let date = new Date(this.installationDate).getTime() / 1000;
    this.luminariaService.infoUpdate(this.selectedLumToEdit.idDispositivo, this.name, this.serialNumber,
      date, this.hasEmergency, this.modelLed, this.lux, this.consumoPorHora, idProyectoUpdtate, idPlanoUpdate, idZonaUpdate).subscribe(result => {
      this.dialogRef.close(true);
    })
  }

  async checkPlanoAndZonaSelected() {
    this.zonas = [];
    this.planos = [];
    this.showZonas = [];
    this.showPlanos = [];

    await this.getPlanosAndZonas(); // wait until all data is loaded

    this.proyectoSelected = this.user.getProyectos().find(proyecto =>
      proyecto.idProyecto == this.selectedLumToEdit.idProyecto
    );

    if (this.proyectoSelected) {
      this.planoSelected = this.planos.find(plano =>
        plano.idPlano == this.selectedLumToEdit.idPlano
      );

      this.showPlanos = this.planos.filter(plano =>
        plano.idProyecto == this.proyectoSelected.idProyecto
      );

      if (this.planoSelected) {
        this.zonaSelected = this.zonas.find(zona =>
          zona.id == this.selectedLumToEdit.idZona
        );

        this.showZonas = this.zonas.filter(zona =>
          zona.idPlano == this.planoSelected.idPlano
        );
      }
    }
  }

  async getPlanosAndZonas(): Promise<void> {
    // Load zonas
    const zonasResp = await this.zonaService.getAll().toPromise();
    this.zonas = <Array<zona>>zonasResp;

    // Load planos for all proyectos
    const proyectos = this.user.getProyectos();

    // Create an array of observables
    const planoRequests: Promise<plano[]>[] = this.user.getProyectos().map(pro =>
      this.planoService.getByIdProyecto(pro.idProyecto).toPromise() as Promise<plano[]>
    );

    const allPlanos: plano[][] = await Promise.all(planoRequests);

    // Manual flatten
    this.planos = ([] as plano[]).concat(...allPlanos);
  }


  selectProyecto(event) {
    this.proyectoSelected = this.user.getProyectos().find(proyecto => proyecto.idProyecto == event.value.idProyecto);
    this.planoSelected = undefined;
    this.zonaSelected = undefined;
    this.showZonas = [];
    this.showPlanos = this.planos.filter(plano => {
      return plano.idProyecto == this.proyectoSelected.idProyecto;
    });

    // Show warning if the project is changed
    this.changingProyecto = this.selectedLumToEdit.idProyecto != "-1"
      && this.selectedLumToEdit.idProyecto != event.value.idProyecto;
  }

  selectPlano(event) {
    this.planoSelected = this.showPlanos.find(plano => plano.idPlano == event.value.idPlano);
    this.zonaSelected = undefined;
    this.showZonas = this.zonas.filter(zona => {
      return zona.idPlano == this.planoSelected.idPlano;
    });
  }

  selectZona(event) {
    this.zonaSelected = this.showZonas.find(zona => zona.id == event.value.id);
  }

  removeLocation() {
    this.showZonas = [];
    this.showPlanos = [];
    this.proyectoSelected = undefined;
    this.planoSelected = undefined;
    this.zonaSelected = undefined;
  }

  maxLengthCheck(event) {
    if (event.target.value.length > event.target.max.length) {
      let number = event.target.value.slice(0, event.target.max.length);
      event.target.value = +number;
      this.lux = +number;
    }
  }

  getModelList(): Model[] {
    return modelList;
  }

}
